// extracted by mini-css-extract-plugin
export default {"Container":"NotificationBell_Container__RUYys","BellButton":"NotificationBell_BellButton__+o8CR"};